import { Form, Button, Container, Alert } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from './authSlice';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../api/api';

export default function ForgotPassword() {
  const [resetEmail, setResetEmail] = useState('');
  const [resetStatus, setResetStatus] = useState(null);
  const [resetError, setResetError] = useState(null);

  const handleResetRequest = async e => {
    e.preventDefault();
    setResetStatus('loading');
    setResetError(null);
    try {
      const res = await api.post('/auth/reset-request', { email: resetEmail });
      if (res.status === 200)
        setResetStatus('sent');
      else
        setResetError(res.data.message || 'Failed to request reset');
      return res.data
    } catch (err) {
      setResetError(err.response?.data?.message || 'Failed to request reset');
    }
    setResetStatus('failed');

  };

  return (
    <>
       <h5>Forgot password?</h5>
       <Form onSubmit={handleResetRequest} className="mt-2">
         {resetError && <Alert variant="danger">{resetError}</Alert>}
         {resetStatus && resetStatus === 'sent' && (
          <>
            <Alert variant="success">
              Temporary password has been sent.
            </Alert>
            <Button as={Link} to="/login" className="ms-2 btn-corrected-path">
              Login with temporary password
            </Button>
          </>
         )}
         {(!resetStatus || resetStatus === 'failed') && (
            <>
              <Form.Group className="mb-2">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={resetEmail}
                  onChange={e => setResetEmail(e.target.value)}
                  required
                />
              </Form.Group>
              <Button
                type="submit"
                size="sm"
                disabled={resetStatus === 'loading'}
              >
                {resetStatus === 'loading' ? 'Sending...' : 'Reset password'}
              </Button>
              <Button as={Link} to="/login" className="ms-2 btn-alternate-path">
                Back to Login
              </Button>
            </>
          )}
      </Form>

    </>
  );
}